<wr-base-dialog status="info" [header]="header" [showCancelButton]="false" submitText="Weiter">
  <p [textContent]="text"></p>
</wr-base-dialog>
